/**
 * The credit-usage meter only renders a trial countdown for the clinician and
 * clinician-practice trial cohorts (`trialRemaining` in the side-nav popover).
 * A header surface that hands its countdown to the meter must stand down on
 * exactly this condition: `isInReverseTrial` alone is wider and covers trials
 * the meter shows no countdown for, which leaves the user with neither.
 *
 * Both cohort booleans already imply an active trial, so callers need no
 * separate `inActiveTrial` conjunct.
 */
export function showsCreditUsageMeterTrialCountdown({
  isClinicianTrialUser,
  isClinicianPracticeTrialUser,
}: {
  isClinicianTrialUser: boolean;
  isClinicianPracticeTrialUser: boolean;
}): boolean {
  return isClinicianTrialUser || isClinicianPracticeTrialUser;
}
